var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVectorblack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 7.93164V4.93164H7.5V7.93164H4.5ZM10.5 7.93164V4.93164H13.5V7.93164H10.5ZM16.5 4.93164H19.5V7.93164H16.5V4.93164ZM4.5 13.9316V10.9316H7.5V13.9316H4.5ZM10.5 13.9316V10.9316H13.5V13.9316H10.5ZM16.5 13.9316V10.9316H19.5V13.9316H16.5ZM4.5 19.9316V16.9316H7.5V19.9316H4.5ZM10.5 19.9316V16.9316H13.5V19.9316H10.5ZM16.5 19.9316V16.9316H19.5V19.9316H16.5Z",
    fill: "#323130"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectorblack);
export default __webpack_public_path__ + "static/media/vectorblack.cb76532842230f537af1868d6b38dc3e.svg";
export { ForwardRef as ReactComponent };